import React from "react";
import GlobalHelper from "../../../Common/Helpers/GlobalHelper";

const TableRow = (props) => {
    const { tarjeta, valorCuenta, permisos, editarTarjeta, eliminarTarjeta, modalidadDistribucionId, estadoSolicitud, solicitudId } = props;
    const iconoEditar = permisos.components.IconoEditar.Locked;
    const iconoBorrar = permisos.components.IconoEliminar.Locked;
    const classItalic = (tarjeta.esNueva == true) ? "italic-row" : ""

    let limite = null;

    //Si la modalidad es mayor a 1 quiere decir que es sin limites
    if (modalidadDistribucionId > 1) {
        limite = (tarjeta.PorcentajeLimiteCompra * valorCuenta / 100)
        limite = tarjeta.PorcentajeLimiteCompra + "% (" + GlobalHelper.ConvertirNumeroMilesMillones(limite) + ")";
    } else {
        limite = "SIN LÍMITE";
    }
    let nombre = tarjeta.ClienteApellido ? tarjeta.ClienteNombre + " " + tarjeta.ClienteApellido : tarjeta.ClienteNombre;

    return (
        <tr className={classItalic}>
            <td>
                <label className="label-secondary">{tarjeta.Ordenamiento}</label>
            </td>
            <td className="td-bold td-bold-black">
                <label className="label-secondary">{nombre}</label>
                {tarjeta.isVigente == true ? <label className="lbl-radio label-4">&nbsp;&nbsp;&nbsp;Vigente</label> : null}
            </td>
            <td className="td-bold td-bold-black">
                <label className="label-secondary">{tarjeta.TarjetaTipoDescripcion}</label>
            </td>
            <td className="td-bold td-bold-black">
                <label className="label-secondary">{limite}</label>
            </td>
            <td>
                {((permisos.components.IconoEditar.Active == true && tarjeta.esNueva == true) ||
                    (permisos.components.IconoEditar.Active == true && tarjeta.TarjetaCreditoEstadoId == 1
                        && tarjeta.SolicitudId == solicitudId)) &&
                    <span className={"ti-pencil ti-md " + (iconoEditar == false ? "clickable" : "")}
                        aria-hidden="true" title={(iconoEditar == false ? "Editar esta tarjeta" : "Bloqueado")}
                        onClick={() => {
                            if (iconoEditar == false) {
                                editarTarjeta(tarjeta);
                            } else { return false; }
                        }}></span>}
            </td>
            <td>
                {((permisos.components.IconoEliminar.Active == true && tarjeta.esNueva == true) ||
                    (permisos.components.IconoEditar.Active == true && tarjeta.TarjetaCreditoEstadoId == 1
                        && tarjeta.SolicitudId == solicitudId)) &&
                    <span className={"ti-trash ti-md " + (iconoBorrar == false ? "clickable" : "")}
                        aria-hidden="true" title={(iconoBorrar == false ? "Eliminar esta tarjeta" : "Bloqueado")}
                        onClick={() => {
                            if (iconoBorrar == false) {
                                eliminarTarjeta(tarjeta.IdReferencia);
                            }
                            else { return false; }
                        }}></span>}
            </td>
        </tr>
    )
}

export default TableRow